import anotherLifeResultChange from './actions/anotherLifeResultChange';
import anotherLifeResultCreate from './actions/anotherLifeResultCreate';
import anotherLifeResultDetail from './actions/anotherLifeResultDetail';
import anotherLifeResultList from './actions/anotherLifeResultList';
import anotherLifeResultListUpload from './mutations/anotherLifeResultListUpload';
import getAnotherLifeResultItems from './getters/getAnotherLifeResultItems';

const actions = {
  anotherLifeResultChange,
  anotherLifeResultCreate,
  anotherLifeResultDetail,
  anotherLifeResultList,
};

const mutations = {
  anotherLifeResultListUpload
};

const getters = {
  getAnotherLifeResultItems
}

export default { actions, mutations, getters}